module.exports = __webpack_public_path__ + "static/media/information.54adc161.svg";